import { AttachFile as AttachFileIcon, Delete as DeleteIcon, Edit as EditIcon, Restore as RestoreIcon, Visibility as VisibilityIcon } from "@mui/icons-material";
import { Box, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material"
import { ActionPerformed } from "../../../../shared_elements/components";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import UploadingIcon from "../../../../shared_elements/components/UploadingIcon";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from "../../../../shared_elements/components/popover";

const RelatedLoansList = ({ uploadedFileData, slug, uploadFileProgressData, viewFileStatus, item, onDelete, onView, onEdit, viewRevisonHistory, bulk, toggleBulkOps, viewFile }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Related Loans Listing`, page_type: page_type, })
    }
    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['D'] }}>
                        <Checkbox size="small" color="primary" checked={bulk?.ids?.find(items => items.id === item.id) ? true : false} onChange={(e) => { toggleBulkOps(e.target.checked, "single", item) }} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className='revision-history' color="primary" fontSize="small" onClick={() => {viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['R'] }}>
                    <Tooltip title="View">
                            <VisibilityIcon color="primary" fontSize="small" sx={{ cursor: "pointer" }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['U'] }}>
                    <Tooltip title="Edit">
                            <EditIcon color="primary" fontSize="small" sx={{ cursor: "pointer" }} onClick={() => { onEdit(); handleItemClicked('EditIcon') }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['D'] }}>
                    <Tooltip title="Delete">
                            <DeleteIcon color="error" fontSize="small" sx={{ cursor: "pointer" }} onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} />
                    </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "related_loan", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count"> ({item.attachments.length}) </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                    </PermissionWrapper>
                    { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.name?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.name ? item.name : "--"} lessMr='name' /></div></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.loan_status ? "Enabled" : "Disabled"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.description?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.description} lessMr='Description' /></div></TableCell>
        </TableRow>
    )
}
export default RelatedLoansList;